import React, { useState } from "react";
import { Link } from "react-router-dom";
import { XIcon, AlertTriangleIcon } from "lucide-react";
import { useOrganization } from "../helpers/useOrganization";
import styles from "./TestModeBanner.module.css";

export function TestModeBanner() {
  const { organization } = useOrganization();
  const [dismissed, setDismissed] = useState(false);

  // Cast organization to check isDemo, since it may not be in the OutputType schema for current_GET but exists in DB.
  // We check truthiness safely.
  const isDemo = organization ? organization.isDemo : false;

  if (!organization || !isDemo || dismissed) {
    return null;
  }

  return (
    <div className={styles.banner} role="alert">
      <div className={styles.content}>
        <AlertTriangleIcon size={16} />
        <span>
          <strong>TEST MODE</strong> — You are currently in test mode. Your data is for testing purposes only.
        </span>
        <Link to="/settings" className={styles.link}>
          Go Live &rarr;
        </Link>
      </div>
      <button 
        className={styles.closeButton} 
        onClick={() => setDismissed(true)}
        aria-label="Dismiss test mode banner"
      >
        <XIcon size={16} />
      </button>
    </div>
  );
}